const locationState = {
    locationId: 'dekluis'
};
export default locationState;
